export const SET_CURRENT_DRAFT_LANG = 'SET_CURRENT_DRAFT_LANG'
export type SET_CURRENT_DRAFT_LANG = typeof SET_CURRENT_DRAFT_LANG

export const SET_CURRENT_DRAFT_PERMISSIONS = 'SET_CURRENT_DRAFT_PERMISSIONS'
export type SET_CURRENT_DRAFT_PERMISSIONS = typeof SET_CURRENT_DRAFT_PERMISSIONS

export const SET_READ_ONLY = 'SET_READ_ONLY'
export type SET_READ_ONLY = typeof SET_READ_ONLY
